import { gql } from "utils/urql";
import { ArticleBioSwanFragment, AuthorBioSwanFragment } from "types/api";
import FacebookIcon from "assets/social-icons/facebook.svg";
import TwitterIcon from "assets/social-icons/twitter.svg";
import EmailIcon from "assets/social-icons/email.svg";
import styles from "./ArticleBio.module.scss";

const AuthorSocialMedia = ({
  displayName,
  socialMedia,
}: Pick<AuthorBioSwanFragment, "displayName" | "socialMedia">) => {
  const facebook = socialMedia.find((social) => social.platform === "FACEBOOK");
  const twitter = socialMedia.find((social) => social.platform === "TWITTER");
  const email = socialMedia.find((social) => social.platform === "EMAIL");
  return (
    <div className={styles.social}>
      {facebook && (
        <a
          className={styles.socialLink}
          href={facebook.url}
          target="_blank"
          rel="noreferrer"
        >
          <FacebookIcon
            title={`${displayName}'s Facebook Profile`}
            className={styles.socialLinkIcon}
          />
          <span className={styles.socialLinkName}>Facebook</span>
        </a>
      )}
      {twitter && (
        <a
          className={styles.socialLink}
          href={twitter.url}
          target="_blank"
          rel="noreferrer"
        >
          <TwitterIcon
            title={`${displayName}'s Twitter Profile`}
            className={styles.socialLinkIcon}
          />
          <span className={styles.socialLinkName}>Twitter</span>
        </a>
      )}
      {email && (
        <a className={styles.socialLink} href={`mailto:${email.url}`}>
          <EmailIcon
            title={`Email ${displayName}`}
            className={styles.socialLinkIcon}
          />
          <span className={styles.socialLinkName}>Email</span>
        </a>
      )}
    </div>
  );
};

const ArticleBio = ({
  index,
  ...author
}: {
  index: number;
} & AuthorBioSwanFragment &
  Pick<ArticleBioSwanFragment, "reviews">) => {
  const { id, displayName, biography, socialMedia } = author;
  return displayName && biography ? (
    <address key={id} id={`article-writer-${index}`} className={styles.root}>
      <div className={styles.content}>
        {biography?.default && (
          <div
            className={styles.bio}
            dangerouslySetInnerHTML={{ __html: biography.default }}
          />
        )}
        {socialMedia.length > 0 && (
          <AuthorSocialMedia
            socialMedia={socialMedia}
            displayName={displayName}
          />
        )}
      </div>
    </address>
  ) : null;
};

ArticleBio.fragment = gql`
  fragment authorBioSwan on Author {
    id
    displayName
    url
    biography {
      default
    }
    socialMedia {
      platform
      url
    }
  }
  fragment articleBioSwan on Article {
    reviews {
      __typename
    }
    authors {
      ...authorBioSwan
    }
  }
`;

export default ArticleBio;
